<template>
  <div id="campaigns">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="float-right mt-2">
              <a
                :class="{'mt-1 btn btn-sm btn-primary': true, 'active':adding}"
                href="javascript:;"
                @click="toggleAdd"
              >Add Campaign <i :class="{'jam':true, 'jam-plus':!adding, 'jam-minus':adding}" /></a>
            </div>
            <div class="section-title">
              Campaigns <span class="section-subtitle d-none d-sm-inline d-md-inline d-lg-inline d-xl-inline">manage</span>
            </div>
            <div class="row d-block">
              <app-template-frm />
            </div>
          </section>
          <div class="clearfix" />
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>
<script>
import templateForm from './form/index.vue';

export default {
    data() {
        return {
            adding: false
        };
    },
    methods: {
        toggleAdd() {
            let val = this.adding;
            return this.adding = !val;
        }
    },
    components: {
        'app-template-frm': templateForm
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/campaigns/index.vue